import { lt } from '@mews/framework';
import { DropDownButton, DropdownItem, Icon, IconName } from '@optimus-web/core';

interface ExportDropdownButtonProps {
    handleExportClick: () => void;
    handleCreateScheduleClick: () => void;
}

export const ExportDropdownButton = ({ handleExportClick, handleCreateScheduleClick }: ExportDropdownButtonProps) => (
    <DropDownButton variant="secondary" label={lt('Export')} size="medium">
        <DropdownItem
            leftDetail={<Icon value={IconName.Exports} />}
            label={lt('ExportToExcel')}
            onClick={handleExportClick}
        />
        <DropdownItem
            leftDetail={<Icon value={IconName.ExportSchedule} />}
            label={lt('CreateExportSchedule')}
            onClick={handleCreateScheduleClick}
        />
    </DropDownButton>
);
